export default class ReverseFlowError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ReverseFlowError';
    }
}